// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    TestPlanAssignmentPayloadAssignment,
    TestPlanAssignmentPayloadAssignmentFromJSON,
    TestPlanAssignmentPayloadAssignmentToJSON,
} from './';

/**
 * 
 * @export
 * @interface TestPlanAssignmentPayload
 */
export interface TestPlanAssignmentPayload {
    /**
     * 
     * @type {string}
     * @memberof TestPlanAssignmentPayload
     */
    executor: TestPlanAssignmentPayloadExecutorEnum;
    /**
     * 
     * @type {string}
     * @memberof TestPlanAssignmentPayload
     */
    assignmentCriteria?: TestPlanAssignmentPayloadAssignmentCriteriaEnum;
    /**
     * 
     * @type {string}
     * @memberof TestPlanAssignmentPayload
     */
    assignmentMethod?: TestPlanAssignmentPayloadAssignmentMethodEnum;
    /**
     * 
     * @type {TestPlanAssignmentPayloadAssignment}
     * @memberof TestPlanAssignmentPayload
     */
    assignment?: TestPlanAssignmentPayloadAssignment;
    /**
     * 
     * @type {number}
     * @memberof TestPlanAssignmentPayload
     */
    project: number;
    /**
     * 
     * @type {number}
     * @memberof TestPlanAssignmentPayload
     */
    testplan: number;
    /**
     * When false (default) the assignment rules are applied only to test cases that are still unassigned, preserving assignees inherited from the test case default and assignees already picked inside the test plan. When true the rules are applied to every test case, replacing existing assignments.
     * @type {boolean}
     * @memberof TestPlanAssignmentPayload
     */
    overrideExistingAssignees?: boolean;
}

export function TestPlanAssignmentPayloadFromJSON(json: any): TestPlanAssignmentPayload {
    return {
        'executor': json['executor'],
        'assignmentCriteria': !exists(json, 'assignment_criteria') ? undefined : json['assignment_criteria'],
        'assignmentMethod': !exists(json, 'assignment_method') ? undefined : json['assignment_method'],
        'assignment': !exists(json, 'assignment') ? undefined : TestPlanAssignmentPayloadAssignmentFromJSON(json['assignment']),
        'project': json['project'],
        'testplan': json['testplan'],
        'overrideExistingAssignees': !exists(json, 'override_existing_assignees') ? undefined : json['override_existing_assignees'],
    };
}

export function TestPlanAssignmentPayloadToJSON(value?: TestPlanAssignmentPayload): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'executor': value.executor,
        'assignment_criteria': value.assignmentCriteria,
        'assignment_method': value.assignmentMethod,
        'assignment': TestPlanAssignmentPayloadAssignmentToJSON(value.assignment),
        'project': value.project,
        'testplan': value.testplan,
        'override_existing_assignees': value.overrideExistingAssignees,
    };
}

/**
* @export
* @enum {string}
*/
export enum TestPlanAssignmentPayloadExecutorEnum {
    Me = 'me',
    Team = 'team'
}
/**
* @export
* @enum {string}
*/
export enum TestPlanAssignmentPayloadAssignmentCriteriaEnum {
    Configuration = 'configuration',
    TestCase = 'testCase'
}
/**
* @export
* @enum {string}
*/
export enum TestPlanAssignmentPayloadAssignmentMethodEnum {
    Automatic = 'automatic',
    Manual = 'manual'
}


